import {getDate, getTs} from '../../../../../../../../library/dates';
import {DEFAULT_TIME_ZONE} from '../../../../../../../../globalVariables/locals';

export const PROMOTION_REQUIRMENTS = {
    default: {
        ticketsNumber: 50,
        amountThreshold: 5000,
        eventActive: '',
        eventDate: getDate(getTs(), DEFAULT_TIME_ZONE),
    },
    oneWeekBeforeEvent: {
        weekBeforeEventDetailed: '',
        cronPowered: '',
    },
    lastMinute: {
        lastMinuteDetailed: '',
        cronPowered: '',
    },
    publishEvent: {
        publishEventDetailed: '',
    }
};